import React, {Component} from 'react';
import FlatButton from 'material-ui/FlatButton';
import moment from 'moment';
import {Modal, ModalBody, ModalHeader, ModalTitle, Table} from 'react-bootstrap';
import swal from 'sweetalert';
import MaskedFormControl from 'react-bootstrap-maskedinput';


var Config = require('../../../config');

class SearchIsste extends Component{

    constructor(props){
        super(props);

        this.handleClose = this.handleClose.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleShow = this.handleShow.bind(this);
/*         this.search_idee = this.search_idee.bind(this);
        this.search_nss = this.search_nss.bind(this);*/
        this.onCheck = this.onCheck.bind(this); 
        this.onSelect = this.onSelect.bind(this);

        this.state = {
            show: false,
            searchType: "",
            curp: "",
            rfc: "",
            nombre: "",
            curp_b: "",
            apellido_p: "",
            apellido_m:"",
            list: [],
            beneficiarios: [],
            search: "",
            nombre_b: "",
            apellido_p_b:"",
            apellido_m_b:"",
        }

    }

    componentDidMount(){
        this.props.onRef(this);
    }

    handleShow(search = 'x'){
        this.setState({
            show:true, 
            search: search,
            beneficiarios:[],
        });
    }

    handleChange(e){
         
        if(e.target.name === 'searchType'){
            this.setState({
                curp:"",
                rfc:"",
                nombre: "",
                curp_b: "",
                apellido_p: "",
                apellido_m:"",
                nombre_b: "",
                apellido_p_b:"",
                apellido_m_b:"",
                list:[],
                beneficiario:[],
                search:"",
            });
        }

        this.setState({[e.target.name]: e.target.value});
        //console.log("Valor de " + e.target.name + ": ", e.target.value);
    }
    handleClose(){
        this.setState({
            show: false,
            searchType:"",
            curp:"",
            rfc:"",
            nombre: "",
            curp_b: "",
            apellido_p: "",
            apellido_m:"",
            nombre_b: "",
            apellido_p_b:"",
            apellido_m_b:"",
            list:[],
            search:"",
        });
    }

    searchIsste(registro){
        if(this.state.searchType !== "" && registro !== ""){
            
            if(this.state.searchType == "CURP" || this.state.searchType == "RFC" || this.state.searchType == "CURP_B"){
                
                //const TokenIsste =  localStorage.getItem("token_issste");

                const subfijo = this.state.searchType == "CURP_B" ? "beneficiario" : "trabajador";
                //console.log(TokenIsste);
                //swal('Success', 'Buscando por ' + this.state.searchType + ': ' + registro, 'info');
                let url = Config.default.issste.url+'/vista/'+subfijo+'/por'+this.state.searchType+'/'+registro;

                //Cambiar este fetch por el endpoint real de ISSSTE y usar "url"
                fetch(Config.default.apiGateway.URL+'petitions/Issste/'+subfijo+'/'+this.state.searchType+'/'+registro, {
                    method:'get',
                    headers: new Headers({
                        'Authorization'	: 'Bearer '+sessionStorage.getItem("token"),
                        'Accept'		: 'application/json',
                        'Content-Type'	: 'application/json'
                    })
                }).then(res =>{
                    this.props.waiting.handleClose();
                    if(res.ok){
                        return res.json();
                    }else{
                        res.text().then((msg)=>{
                            swal('Error', msg, 'error');
                        });
                    }
                }).then(response => {
                    if(response !== undefined && response !== null){ 
                        let data = JSON.parse(response);
                        this.setState({list:data});
                        this.setState({beneficiarios: this.state.list[0].beneficiarios});
                       
                    }
                })   

            }else if(this.state.searchType == "NOMBRE" || this.state.searchType == "NOMBRE_B"){
            
                let tipoBusqueda = this.state.searchType == "NOMBRE" ? 1 : 2;
                let data;

                if(tipoBusqueda == 1){
                    data = {
                        "nombre": this.state.nombre,
                        "apellidoP": this.state.apellido_p,
                        "apellidoM": this.state.apellido_m
                    };
                }else{
                    data = {
                        "nombre": this.state.nombre_b,
                        "apellidoP": this.state.apellido_p_b,
                        "apellidoM": this.state.apellido_m_b
                    };
                }
             
                fetch(Config.default.apiGateway.URL+'petitionsIsssteN/'+tipoBusqueda, {
                    method:'post',
                    body: JSON.stringify(data),
                    headers: new Headers({
                        'Authorization'	: 'Bearer '+sessionStorage.getItem("token"),
                        'Accept'		: 'application/json',
                        'Content-Type'	: 'application/json'
                    })
                }).then(res =>{
                    this.props.waiting.handleClose();
                    if(res.ok){
                        return res.json();
                    }else{
                        res.text().then((msg)=>{
                            this.state.list = [];
                            swal('Error', msg, 'error');
                        });
                    }
                }).then(response => {
                    if(response !== undefined && response !== null){ 
                        let data = JSON.parse(response);
                        //console.log("Data recibida de busqueda por nombre: ", data);
                       
                            this.setState({list:data});
                            this.setState({beneficiarios: this.state.list[0].beneficiarios});
                    }
                })   
            }else{
                swal('Error', 'Tipo de busqueda no valido' + this.state.searchType, 'error');
            }
        }else{
            swal('Error', 'Debe seleccionar un tipo de busqueda y escribir un criterio', 'error');
        }
    }

    onCheck(e, i){
        let list = this.state.list;
        
        list.forEach((item, j) => {
            item.check = false;

            if(j === i){
                item.check = e.target.checked;
                item.selected = e.target.checked;
            }

            
        });
       this.setState({list:list});
        //console.log("Lista actualizada: ", this.state.list);
    }

    onCheck2(z, x){
        this.state.beneficiario = [];
        let list = this.state.beneficiarios;
        
        list.forEach((item, j) => {
            item.check = false;

            if(j === x){
                item.check = z.target.checked;
                item.selected = z.target.checked;

                this.state.beneficiario.push(item);
            }

        });
       
        //console.log("Lista actualizada: ", this.state.beneficiario); 
    }

    onSelect(){

       /*  if(his.state.beneficiario.length == undefined  )
        {
            this.handleClose();
        } */
            
        var list = this.state.beneficiario.length > 0 ? this.state.beneficiario : this.state.list;

        //console.log("Lista para seleccionar: ", list);
        var selected = [];

        list.forEach((item)=>{
            if(item.check){
                if(this.state.search !== 'donor'){
                    item.id = item.patient_id;
                }

                selected = [item];

                //console.log("Elementos seleccionado: ", selected);
            }
        });

        //console.log("Elementos seleccionados: ", selected[0]);

       if(this.state.search_type !== ""){
            if(selected.length > 0){
                this.props.updateState(selected);
                this.handleClose();
            }else{
                swal('Error', 'Debe seleccionar un nombre', 'error');
            }
        }else{
            swal('Error', 'Debe seleccionar un tipo de busqueda', 'error');
        }
        
    }
    render()
    {
        return (
            <Modal bsSize="lg" show={this.state.show} onHide={this.handleClose}>
            <ModalHeader closeButton>
                <ModalTitle>Busqueda en ISSSTE</ModalTitle>
            </ModalHeader>
            <ModalBody>
                <div className='form-group row'>
                    <div className='form-group col-xs-12'>
                        <div className='col-xs-12 col-sm-2'>
                            <span className='span-min'>Tipo de Busqueda</span>
                            <select className='form-control' id='searchType' value={this.state.searchType}
                            onChange={this.handleChange} name='searchType'>
                                <option value=""> Seleccione</option>
                                <option value="CURP">CURP</option>
                                <option value="RFC">RFC</option>
                                <option value="NOMBRE">Nombre</option>
                                <option value="CURP_B">CURP Beneficiario</option>
                                <option value="NOMBRE_B">Nombre Beneficiario</option>
                            </select>
                        </div>

                        {this.state.searchType === 'CURP' && (
                            <div className='col-xs-12 col-sm-10'>
                                <span className='span-min'>CURP</span>
                                <input type='text' className='form-control' id='curp' value={this.state.curp}
                                onChange={this.handleChange} name='curp' mask='AAAA111111AAAAAA11'/>
                                <button type="button" className="btn btn-info" style={{width:'100%'}} title="Buscar Issste"
                                            onClick={() => this.searchIsste(this.state.curp)}>
                                            BUSCAR
                                        </button>
                            </div>
                            
                        )}
                        {this.state.searchType === 'RFC' && (
                            <div className='col-xs-12 col-sm-10'>
                                <span className='span-min'>RFC</span>
                                <input type='text' className='form-control' id='rfc' value={this.state.rfc}
                                onChange={this.handleChange} name='rfc' mask='AAAA111111AAA'/>
                                <button type="button" className="btn btn-info" style={{width:'100%'}} title="Buscar Issste"
                                            onClick={() => this.searchIsste(this.state.rfc)}>
                                            BUSCAR
                                        </button>
                            </div>
                            
                        )}
                        {this.state.searchType === 'NOMBRE' && (
                            <div className='col-xs-12 col-sm-10'>
                                <span className='span-min'>Nombre</span>
                                <input type='text' className='form-control' id='nombre' value={this.state.nombre}
                                onChange={this.handleChange} name='nombre'/>
                                <span className='col-xs-12 col-sm-10'>Apellido Paterno</span>
                                <input type='text' className='form-control' id='ap_paterno' value={this.state.apellido_p}
                                onChange={this.handleChange} name='apellido_p'/>
                                <span className='col-xs-12 col-sm-10'>Apellido Materno</span>
                                <input type='text' className='form-control' id='ap_materno' value={this.state.apellido_m}
                                onChange={this.handleChange} name='apellido_m'/>
                                <button type="button" className="btn btn-info" style={{width:'100%'}} title="Buscar Issste"
                                            onClick={() => this.searchIsste(this.state.nombre)}>
                                            BUSCAR
                                        </button>
                            </div>
                            
                        )}
                        {this.state.searchType === 'CURP_B' && (
                            <div className='col-xs-12 col-sm-10'>
                                <span className='span-min'>CURP Beneficiario</span>
                                <input type='text' className='form-control' id='curp_b' value={this.state.curp_b}
                                onChange={this.handleChange} name='curp_b' mask='AAAA111111AAAAAA11'/>
                                <button type="button" className="btn btn-info" style={{width:'100%'}} title="Buscar Issste"
                                        onClick={() => this.searchIsste(this.state.curp_b)}>
                                            BUSCAR
                                        </button>
                            </div>
                            
                        )}
                        {this.state.searchType === 'NOMBRE_B' && (
                            <div className='col-xs-12 col-sm-10'>
                                <span className='span-min'>Nombre Beneficiario</span>
                                <input type='text' className='form-control' id='nombre_b' value={this.state.nombre_b}
                                onChange={this.handleChange} name='nombre_b'/>
                                 <span className='span-min'>Apellido Paterno Beneficiario</span>
                                <input type='text' className='form-control' id='ap_paterno_b' value={this.state.apellido_p_b}
                                onChange={this.handleChange} name='apellido_p_b'/>
                                 <span className='span-min'>Apellido Materno Beneficiario</span>
                                <input type='text' className='form-control' id='ap_materno_b' value={this.state.apellido_m_b}
                                onChange={this.handleChange} name='apellido_m_b'/>
                                
                                <button type="button" className="btn btn-info" style={{width:'100%'}} title="Buscar Issste"
                                        onClick={() => this.searchIsste(this.state.nombre_b)}>
                                            BUSCAR
                                </button>
                            </div>
                            
                        )}
                    </div>
                    <div className='form-group col-xs-12'>
                        <Table responsive hover>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Número ISSSTE</th>
                                    <th>Nombre</th>
                                    <th>A. Paterno</th>
                                    <th>A. Materno</th>
                                    <th>Sexo</th>
                                    <th>CURP</th>
                                    <th>RFC</th>
                                    <th>TIPO</th>
                                    <th>Clinica</th>
                                    <th>Clave Clinica</th>
                                    {/* <th>Fecha Nacimiento</th>
                                    <th>Fecha Limite Vigencia</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.list.map((list, i) => (
                                    <tr key={i}>

                                            <td>
                                                <input type='checkbox' checked={list.check} value={list.check} onChange={(e)=>this.onCheck(e, i)} />
                                            </td>
                                        <td>{list.num_issste}</td>
                                        <td>{list.nom_tra}</td>
                                        <td>{list.apa_tra}</td>
                                        <td>{list.ama_tra}</td>
                                        <td>{list.sexo}</td>
                                        <td>{list.curp_tra}</td>
                                        <td>{list.rfc_tra}</td>
                                        <td>{list.tipo_dh}</td>
                                        <td> {list.nom_clin}</td>
                                        {/* <td> {list.cve_clin}</td> */}
                                    </tr>
                                ))} 
                                    
                                    {this.state.beneficiarios.map((ben, x) => (
                                        <tr key={x}>
                                            <td>
                                                <input type='checkbox' checked={ben.check} value={ben.check} onChange={(z)=>this.onCheck2(z, x)} />
                                            </td>
                                                <td>{ben.ito_id}</td>
                                                <td>{ben.nombre}</td>
                                                <td>{ben.apellido_paterno}</td>
                                                <td>{ben.apellido_materno}</td>
                                                <td>{ben.sexo}</td>
                                                <td>{ben.curp}</td>
                                                <td>Beneficiario</td>
                                                <td>Beneficiario</td>
                                                <td>Beneficiario</td>
                                                <td>Beneficiario</td>
                                            </tr>
                                    ))} 
                            </tbody>
                        </Table>
                    </div>
                </div>
            </ModalBody>
            <Modal.Footer>
                <FlatButton primary={true} label="Cancelar"  onClick={this.handleClose}/>

                 <FlatButton primary={true} label="Aceptar"  disabled={this.state.list.length === 0} onClick={this.onSelect}/>
            </Modal.Footer>
        </Modal>
        )
    }
}

export default SearchIsste;